<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
          <div v-if="ifelse == '1'">
<el-form :label-position="labelPosition" label-width="116px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item label="点位名称">
        <el-input v-model="formLabelAlign.spotName" size="small"></el-input>
    </el-form-item>
    <el-form-item label="点位编码">
        <el-input v-model="formLabelAlign.spotCode" placeholder="名称拼音首字母大写)" size="small"></el-input>
    </el-form-item>
    <el-form-item label="所属系统">
        <el-select  clearable v-model="value" @change="SubordinateChange(value)" placeholder="请选择所属系统">
            <el-option
            v-for="item in SubordinateList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
    </el-form-item>
 <el-form-item label="点位类型">
         <el-select  clearable v-model="PointTypevalue" @change="PointTypeChange(PointTypevalue)" placeholder="请选择点位类型">
                    <el-option
                    v-for="item in PointTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="项目(小区)">
        <el-select  clearable v-model="Classifyvalue"  @change="ClassifyChange(Classifyvalue)" placeholder="请选择项目(小区)">
            <el-option
            v-for="item in ClassifyNameList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
        </el-select>
    </el-form-item>
        <el-form-item label="地址">
        <el-input v-model="formLabelAlign.location" size="small"></el-input>
    </el-form-item>
        <el-form-item label="巡检次数(数字)">
        <el-input v-model="formLabelAlign.insNum" size="small"></el-input>
    </el-form-item>
            <el-form-item label="间隔时间(小时)">
        <el-input v-model="formLabelAlign.insTime" size="small"></el-input>
    </el-form-item>
        <el-form-item label="备注">
        <el-input v-model="formLabelAlign.ramark" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div v-else>
  <div class="content" id="printTest">
      <div style="width: 310px;height: 210px;padding: 10px;border: 3px solid #337E62;margin:20px auto;position: relative;">
        <img src="../../assets/images/YongLv.png" alt="" width="55px" style="float:right;" height="20px" srcset="">
        <div style="color:black;margin-top:5px;width:310px;text-align: left;font-size:6px">
          点位编码：{{this.PTcode}}
        </div>
        <div style="color:black;margin-top:10px;width:310px;text-align: left;font-size:6px">
          点位名称：{{this.PTname}}
        </div>
        <div style="color:black;margin-top:10px;width:310px;text-align: left;font-size:6px">
          项目名称：{{this.PTitemName}}
        </div>
          <div style="padding: 2px; width: 120px;height: 120px;margin-top:6px;margin-left: 3px;border: 3px dashed #9B9A9B; border-radius: 10px;">
               <vue-qr :logoSrc="imageUrl" :text="PTtext" :size="110" :margin="0" colorLight="#ffffff" colorDark="#8bc34a"></vue-qr>
          </div>
          <img src="../../assets/images/figure.png" alt="" style="position: absolute; right:20px;top:80px" width="100px" height="148px"  srcset="">
      </div>
  </div>
</div>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="ifelse == '1'" @click="modification()" v-debounce>确 定 </el-button>
        <el-button type="primary" v-else-if="ifelse=='2'" v-print="'#printTest'" @click="printTest()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2' 
import vueQr from 'vue-qr'
export default {
 components: {vueQr},
  name: "LevelManagementDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},

       SubordinateList:[],
        value:"",
        valueName:"",
        PointTypeList:[],
        PointTypevalue:"",
        PointTypeName:'',
        
        ClassifyNameList:[],
        Classifyvalue:"",
        orgId:"",
        rowId:"",
        ifelse:"",


        PTcode:"",
        PTname:"",
        PTitemName:'',
        PTtext:"",
        projectId:"",
        orgIdS:"",

        imageUrl:require("../../assets/images/logo.png"),
    };
  },
  methods: {
    SubordinateChange(res){
      for(let val of this.SubordinateList){
        if(val.value == res){
          this.valueName = val.label
              this.$http.get("/inspect/stand/getSpotType?system="+val.label).then((res)=>{
              let data = res.data
              let arr = []
              if(data.code == 200){
                for(let i = 0;i<data.data.length;i++){
                  let obj = {
                    "value":i,
                    "label":data.data[i]
                  }
                  arr.push(obj)
                }
                this.PointTypeList = arr
              }else{
                this.$message.error(data.msg)
              }
              })
        }
      }
    },
    PointTypeChange(res){
      for(let val of this.PointTypeList){
        if(val.value == res){
          this.PointTypeName = val.label
        }
      }
    },
    ClassifyChange(res){
      for(let val of this.ClassifyNameList){
        if(val.id == res){
          this.orgId = val.id
          this.orgName = val.name
        }
      }
    },
    getUserOffice() {
      this.$http.get("/inspect/project/list").then((res) => {
          if(res.data.code == 200){
            this.ClassifyNameList = res.data.data
          }else{
            this.$message.error(res.data.msg)
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },

    modification(){
      if(this.title == "添加巡检点位"){
          let obj  = {
            "spotName":this.formLabelAlign.spotName,
            "projectId":this.orgId,
            "projectName":this.orgName,
            "spotCode":this.formLabelAlign.spotCode,
            "fields":this.valueName,
            "field":this.PointTypeName,
            "location":this.formLabelAlign.location,
            "insNum":this.formLabelAlign.insNum,
            "insTime":this.formLabelAlign.insTime,
            "ramark":this.formLabelAlign.ramark
          }
          if(obj.spotName == undefined || obj.spotName == ""){

          }else if(obj.spotCode == undefined || obj.spotCode == ""){

          }else if(obj.location == undefined || obj.location == ""){

          }else if(obj.fields == undefined || obj.fields == "" ){

          }else if(obj.field == undefined || obj.field == "" ){
            
          }else{
            this.$http.post(this.$requestUrl.POST_SPOT_SEVE,obj).then((res) => {
              let data = res.data
              if(data.code == 200){
                this.dialogVisible = false
                this.$emit("dialogVisible",false)
                this.$message({
                  message: data.msg,
                  type: 'success'
                });
              }else{
                this.$message.error(data.msg)
              }
            }).catch(() => {
                  this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
          }
          
      }else if(this.title == "修改巡检点位"){
            if(!isNaN(this.value)){
              for(let val of this.SubordinateList){
                if(this.value == val.value){
                  this.valueName = val.label
                }
              }
            }else{
              this.valueName = this.value
            }
            if(!isNaN(this.PointTypevalue)){
                for(let val of this.PointTypeList)  {
                  if(this.PointTypevalue == val.value){
                    this.PointTypeName = val.label
                  }
                }
            }else{
              this.PointTypeName = this.PointTypevalue
            }
            if(!isNaN(this.Classifyvalue)){}else{
              for(let val of this.ClassifyNameList){
                if(this.Classifyvalue == val.id){
                  this.orgId = val.id
                  this.orgName = val.label
                }
              }
            }
          let obj  = {
            "spotId":this.rowId,
            "spotName":this.formLabelAlign.spotName,
            "projectId":this.projectId,
            "projectName":this.orgName,
            "spotCode":this.formLabelAlign.spotCode,
            "fields":this.valueName,
            "field":this.PointTypeName,
            "location":this.formLabelAlign.location,
            "insNum":this.formLabelAlign.insNum,
            "insTime":this.formLabelAlign.insTime,
            "ramark":this.formLabelAlign.ramark
          }
          if(obj.spotName == undefined || obj.spotName == ""){
              console.log(1)
          }else if(obj.spotCode == undefined || obj.spotCode == ""){
  console.log(1)
          }else if(obj.location == undefined || obj.location == ""){
  console.log(1)
          }else if(obj.fields == undefined || obj.fields == "" ){
  console.log(1)
          }else if(obj.field == undefined || obj.field == "" ){
              console.log(1)
          }else{
            this.$http.post(this.$requestUrl.POST_SPOT_UPDETE,obj).then((res) => {
              let data = res.data
              if(data.code == 200){
                this.dialogVisible = false
                this.$emit("dialogVisible",false)
                this.$message({
                  message: data.msg,
                  type: 'success'
                });
              }else{
                this.$message.error(data.msg)
              }
            }).catch(() => {
                  this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
          }
      }
    },
    printTest(){},
    qrcodeimg(text){
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: text, // 需要转换为二维码的内容
          width: 105,
          height: 105,
          colorDark: "#8bc34a",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
          src:"../../assets/images/logo.png"
        });
    },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
  mounted() {
    this.getUserOffice()
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
    //页面销毁之前
  beforeDestroy() {
  },
  //页面销毁之后
  destroyed() {

  },
  //页面视图数据更新之前
  beforeUpdate() {

    
  },
  //页面视图数据更新之后
  updated() {
    if(this.ifelse == '2'){
      this.qrcodeimg(this.PTtext)
    }
  },
}
</script>

<style scoped lang="scss">
		.content{
			border: 1px solid #000;
			margin:0 auto;
			page-break-after:always;
      background: #fff;
		}
    .qrcode{
      margin-top: 2px;
      margin-left: 2px;
    }
</style>